import { render, staticRenderFns } from "./ParcelamentoBoleto.vue?vue&type=template&id=3dd15cd8"
import script from "./ParcelamentoBoleto.vue?vue&type=script&lang=js"
export * from "./ParcelamentoBoleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports